var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course"},[_c('headers'),_c('router-view'),_c('footers')],1)}
var staticRenderFns = []

export { render, staticRenderFns }